var exports = {
  "Im": "xa15a2ab7--8b7aab--comment",
  "K4": "xa15a2ab7--8b7aab--text_block",
  "E": "xa15a2ab7--8b7aab--text_block--editing",
  "bi": "xa15a2ab7--8b7aab--text_block--pointer",
  "ZT": "xa15a2ab7--8b7aab--cancel",
  "MP": "xa15a2ab7--8b7aab--hiddendiv",
  "QA": "xa15a2ab7--8b7aab--button_submit",
  "RC": "xa15a2ab7--8b7aab--preloader",
  "z3": "xa15a2ab7--8b7aab--error",
  "H_": "xa15a2ab7--8b7aab--error--open",
  "y9": "xa15a2ab7--8b7aab--print_mode",
};

module.exports = exports;
